import gql from "graphql-tag";

export const setupPasswordWithActionCode = gql`
  mutation SetupPasswordWithActionCode($email: String!, $code: String!, $password: String!) {
    SetupPasswordWithActionCode(input: { email: $email, code: $code, password: $password }) {
      success
    }
  }
`;
